<!-- Комментарий к расходу. -->
<template>
  <BaseFormSection title="Комментарий" icon="comment">
    <BaseFormField
      label="Комментарий"
      for-id="comment"
      :filled="isFieldFilled('comment')"
      wide
    >
      <base-textarea
        id="comment"
        :model-value="expense.comment"
        @update:model-value="$emit('update-field', 'comment', $event)"
      />
    </BaseFormField>
  </BaseFormSection>
</template>

<script>
export default {
  name: "ExpenseCommentSection",

  props: {
    expense: { type: Object, required: true },
  },

  emits: ["update-field"],

  methods: {
    isFieldFilled(field) {
      const value = this.expense[field];
      return value !== null && value !== undefined && value !== "";
    },
  },
};
</script>
